import { Notifications } from "modules/notifications";

const NotificationsPage = () => {
  return <Notifications />;
};

export default NotificationsPage;
